import { useCallback, useEffect, useRef, useState } from "react";

/** Soft re-anchor after filter-from-cell — plan/30+35 (~1.5s). */
export const LIST_ROW_FLASH_MS = 1500;

/**
 * Ephemeral highlight of a doc row after a filter-from-cell *set*.
 * Not stored in the URL.
 */
export function useListRowFlash(ms = LIST_ROW_FLASH_MS) {
  const [flashId, setFlashId] = useState<string | null>(null);
  const timerRef = useRef<number | null>(null);

  const clearFlash = useCallback(() => {
    if (timerRef.current != null) {
      window.clearTimeout(timerRef.current);
      timerRef.current = null;
    }
    setFlashId(null);
  }, []);

  const flashRow = useCallback(
    (docId: string) => {
      if (!docId) return;
      if (timerRef.current != null) window.clearTimeout(timerRef.current);
      setFlashId(docId);
      timerRef.current = window.setTimeout(() => {
        setFlashId(null);
        timerRef.current = null;
      }, ms);
    },
    [ms],
  );

  useEffect(() => () => clearFlash(), [clearFlash]);

  return { flashId, flashRow, clearFlash };
}

/** Flash only when the toggle *sets* a filter (not clear / reset). */
export function shouldFlashAfterToggle(
  next: string,
  clearedValue: string,
): boolean {
  return next !== clearedValue;
}
